import { render, staticRenderFns } from "./_CollapseItem.vue?vue&type=template&id=b7cd9a1e&scoped=true"
import script from "./_CollapseItem.vue?vue&type=script&lang=js"
export * from "./_CollapseItem.vue?vue&type=script&lang=js"
import style0 from "./_CollapseItem.vue?vue&type=style&index=0&id=b7cd9a1e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cd9a1e",
  null
  
)

export default component.exports